import { Box, Checkbox, IconButton, Tooltip } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ItemMenu } from '../../../../../components/baseMenu'
import { Constants } from '../../../../../utils/constants'
import { Roles, Status } from '../../../../../utils/enums'
import { icons } from '../../../../../utils/icons'
import { menuItems, menuList } from '../constants/menu'
import { useStyles } from '../styles'
import { FrequencyEnumTable } from '../../../../calendar/pages/form/components/steps/configCalendar/enums'
import { getLocalStorage } from '../../../../../utils/crud/crypt'
import { HeaderRowCheckBox } from '../../../../calendar/pages/main/components/headerRowCheckBox'

const useTable = (payload: {
  row: {
    division: string
    user: string
    questionnaire: string
    available_to: string
    reportUrl: string
    status: {
      value: Status
      color: string
      text: string
    }
  }[]
}) => {
  const { t } = useTranslation()
  const styles = useStyles()
  const state = getLocalStorage()
  const [isChecked, setIsChecked] = useState(false)
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [notFolioSelected, setNotFolioSelected] = useState<number[]>([]);
  const [detail, setDetail] = useState<{
    id: number
    reportUrl: string | null
    positionMenu: Record<string, unknown>
    anchor: null | HTMLButtonElement
    menu: ItemMenu[]
    typeOption: FrequencyEnumTable;
    serieId?: number;
  }>({
    id: 0,
    reportUrl: '',
    positionMenu: {},
    anchor: null,
    menu: menuItems,
    serieId: undefined,
    typeOption: FrequencyEnumTable.FRRE,
  })

  const closeMenu = () => {
    setDetail((prev) => ({
      ...prev,
      anchor: null,
    }))
  }

  const addReportUrl = ({ reportUrl }: { reportUrl: string | null }) => {
    setDetail(prev => ({
      ...prev,
      reportUrl
    }))
  }

  const handleHeaderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedIds([]);
    setNotFolioSelected([]);
    if (event.target.checked) {
      setIsChecked(true)
    } else {
      setIsChecked(false)
    }
  };

  const columns: any[] = [
    {
      field: 'checkbox',
      headerName: '',
      label: (
        <Checkbox
          checked={isChecked}
          onChange={handleHeaderChange}
          color="primary"
        />
      ),
      renderCell: (params: any) => {
        const status = params?.row?.status?.value
        const validation = (params.row.createById == state.id && status == Status.TO_BE_STARTED  ) ||  state.role == Roles.ADMIN
        return (
            <HeaderRowCheckBox
              id={params.row.id}
              isChecked={isChecked}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              notFolioSelected={notFolioSelected}
              setNotFolioSelected={setNotFolioSelected}
              disabled={!validation}
            />
        )
      }
    },
    {
      id: 'division',
      label: t('general.tags.division'),
      sortable: true,
      minWidth: 50,
    },
    {
      id: 'user',
      label: t('general.tags.assignedUser'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'store',
      label: t('general.tags.idStore'),
      sortable: true,
      minWidth: 140,
    },
    {
      id: 'questionnaire',
      label: t('general.tags.questionnaire'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'frequencyType',
      label: t('general.tags.frequency'),
      //sortable: true,
      minWidth: 100,
    },
    {
      id: 'scheduleType',
      label: t('general.tags.type'),
      minWidth: 100,
    },
    {
      id: 'available_from',
      label: t('general.tags.available_from'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'available_to',
      label: t('general.tags.available_to'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'status',
      label: t('general.tags.status'),
      minWidth: 100,
    },
    {
      id: 'action',
      label: t('general.tags.action'),
      minWidth: 50,
      renderCell: (params: any) => {
        const id = params?.row?.id
        return (
          <Box sx={styles.containerStatus}>
            <Tooltip title={t('ToolTips.seeActions')}>
              <IconButton
                onClick={(e) => {
                  const status = params?.row?.status?.value
                  const type: FrequencyEnumTable = params?.row?.frequencyTypeValue;
                  const validation = !!(params.row.createById !== state.id) && state.role !== Roles.ADMIN

                  let baseMenu = menuList[status as Status] || [];

                  if (state.role !== Roles.ADMIN && status !== Status.TO_BE_STARTED) {
                    baseMenu = baseMenu.filter(value => value !== 7 && value !== 8);
                  }

                  let menu: ItemMenu[] = menuItems
                    .filter(item => baseMenu.includes(item.value))
                    .filter(item => { if (type === FrequencyEnumTable.FRRE || type === FrequencyEnumTable.UNIQUE) { return item.value !== 6 && item.value !== 7; } return true; })
                    .filter(item => { if (validation) { return ![8, 7, 1, 6].includes(item.value) } return true; });

                  setDetail({
                    id,
                    serieId: params.row.serieId,
                    reportUrl: params?.row?.reportUrl,
                    positionMenu:
                      payload?.row?.length < Constants.numberOfRows
                        ? {
                          top: 0,
                          left: '-30px',
                        }
                        : {
                          top: `${e.clientY}px`,
                          left: `${e.clientX - 120}px`,
                        },
                    anchor: e.currentTarget,
                    typeOption: params?.row?.frequencyTypeValue as FrequencyEnumTable,
                    menu: menu,
                  })
                }}
              >
                {icons('moreHoriz')}
              </IconButton>
            </Tooltip>
          </Box>
        )
      },
    },
  ]

  return { columns, detail, closeMenu, addReportUrl, setNotFolioSelected, notFolioSelected, setSelectedIds, selectedIds, isChecked }
}

export { useTable }
